import { getCookiesAsObject } from '@whitelabel/helpers/utils';
import { AUTH_TOKEN_STORAGE_NAME } from '@whitelabel/rentalcover-shared/helpers/constants';

export const getRCAuthToken = (): string | undefined => getCookiesAsObject()?.[AUTH_TOKEN_STORAGE_NAME];
